import { restClient } from '@/Core'

import type { DiskAdminPerson } from '../Contracts/DiskAdmin'

/**
 * Співробітник без «Мого диска» — для картки `/disk/admin/storage/user:<uuid>`:
 * `GET /services/users/{uuid}` (картка довідника співробітників).
 */
export const LoadDiskAdminPersonTask = async (uuid: string): Promise<DiskAdminPerson> => {
    const user = (await restClient.get(`/services/users/${encodeURIComponent(uuid)}`, {}, { forceRefresh: true })) as unknown as {
        uuid?: string
        fullName?: string
        shortName?: string
        firstName?: string
        middleName?: string
        lastName?: string
        status?: string
        position?: string | null
        photoUrl?: string | null
    } | null

    const name =
        user?.fullName ?? ([user?.lastName, user?.firstName, user?.middleName].filter(Boolean).join(' ') || user?.shortName || null)

    return {
        uuid: user?.uuid ?? uuid,
        name,
        photoUrl: user?.photoUrl ?? null,
        ...(user?.status !== undefined ? { status: user.status } : {}),
        position: user?.position ?? null,
        departments: [],
    }
}
